export default "__VITE_ASSET__CG6oMx8s__"